export default function HeroSection() {
  const stats = [
    { label: '每日更新', value: '200+' },
    { label: '高清片源', value: '10万+' },
    { label: '流畅不卡', value: '99.9%' },
  ];

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20atmosphere%20with%20warm%20golden%20and%20amber%20light%20streaks%20across%20a%20theater%20auditorium%20curtain%20texture%2C%20rich%20deep%20red%20velvet%20drapes%2C%20soft%20dramatic%20lighting%2C%20elegant%20film%20projection%20ambiance%2C%20abstract%20bokeh%20effect%2C%20luxurious%20movie%20palace%20interior%20mood%2C%20no%20text%2C%20no%20people&width=1600&height=900&seq=hero-bg-beiwo&orientation=landscape"
          alt="被窝网电影影视氛围背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-0">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/15 border border-accent-400/30 mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
              <span className="text-xs font-medium text-accent-300 whitespace-nowrap">免费 · 高清 · 不缓冲 · 每日更新</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              被窝网电影 — 海量高清影视资源聚合平台
            </h1>

            <p className="text-base md:text-lg text-white/75 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-2">
              被窝网电影官方平台，汇集全网最新电影、热门电视剧、高分综艺与经典动漫资源，所有内容免费在线观看，高清画质流畅不缓冲。无论你是追剧党还是电影迷，被窝电影网大全都能满足你对影视的全部想象。
            </p>
            <p className="text-sm text-white/55 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              当前热推：暑期档强片连映，悬疑犯罪、科幻巨制、国漫崛起，每日凌晨自动更新最新片源，陪你度过每一个窝在被窝里的精彩夜晚。
            </p>

            <div className="flex items-center justify-center lg:justify-start gap-8 mb-8">
              {stats.map((s) => (
                <div key={s.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-accent-400" style={{ fontFamily: 'var(--font-heading)' }}>
                    {s.value}
                  </div>
                  <div className="text-xs text-white/55 mt-1 whitespace-nowrap">{s.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-white font-medium rounded-full text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
              >
                <i className="ri-fire-line"></i>
                查看热播榜单
              </a>
              <a
                href="#media"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#media')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-7 py-3 bg-white/10 text-white font-medium rounded-full text-sm whitespace-nowrap cursor-pointer hover:bg-white/20 transition-colors backdrop-blur-sm border border-white/15"
              >
                <i className="ri-play-circle-line"></i>
                精彩预告速看
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[520px] aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20film%20reel%20and%20projector%20beam%20illuminating%20a%20dark%20elegant%20theater%20interior%20with%20red%20velvet%20curtains%20dramatic%20golden%20spotlight%2C%20movie%20clapperboard%20in%20foreground%2C%20rich%20amber%20and%20crimson%20tones%2C%20classic%20hollywood%20glamour%20atmosphere%2C%20no%20text%2C%20no%20people&width=1040&height=780&seq=hero-visual-beiwo&orientation=landscape"
                alt="被窝网电影主视觉 - 影院级观影体验"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent rounded-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}